/* unplugin-vue-components disabled */import { render } from "./MergeModeView.vue?vue&type=template&id=01098450&scoped=true"
import script from "./MergeModeView.vue?vue&type=script&lang=js"
export * from "./MergeModeView.vue?vue&type=script&lang=js"

import "./MergeModeView.vue?vue&type=style&index=0&id=01098450&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01098450"]])

export default __exports__